export default __webpack_public_path__ + "static/media/gozero.dcfbd00e.jpg";